export const MAX_ENTITIES_NUMBER_PER_REQUEST = 2000;
export const USER_TENANT_MEMBERSHIPS_MAX_ENTITIES_NUMBER_PER_REQUEST = 5000;
export const NUMBER_OF_RETRIES = 3;
